import { isMockServices } from 'src/utils';
import { QueryFunction } from '@tanstack/react-query';
import mock from '../utils/mock';
import { authTokenHttp } from '../utils/authTokenHttp';
import type { IncomeFile } from './types.d';
import { mockIncomeData } from './mockData';

export interface GetIncomeHistoryParams {
  loanId: string;
}

export interface IncomeHistoryResponse {
  success: boolean;
  data: IncomeFile[];
}

const getIncomeHistory: QueryFunction<
  IncomeHistoryResponse,
  ['/income/history', GetIncomeHistoryParams]
> = async ({ queryKey }) => {
  const [, params] = queryKey;

  if (isMockServices()) {
    return await mock({ success: true, data: mockIncomeData.data.files });
  }

  const response = await authTokenHttp<IncomeHistoryResponse>(
    `/loans/${params.loanId}/income-clarity/history`,
    {
      method: 'GET',
    },
  );

  if (!response.data) {
    throw new Error('No income history received from server');
  }

  if (!response.data.success) {
    throw new Error('Income history request was not successful');
  }

  return response.data;
};

export default getIncomeHistory;
